"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m19 18.5-.006.067V20.5c0 1.93-1.57 3.5-3.499 3.5H8.498A3.503 3.503 0 0 1 5 20.5v-17C5 1.57 6.57 0 8.498 0h6.997c1.93 0 3.498 1.57 3.498 3.5l.003.975.004.068-.006.066.002 13.824.004.067ZM17.994 4.042V3.5c0-1.378-1.122-2.5-2.499-2.5H8.498A2.503 2.503 0 0 0 6 3.5v.542h11.994Zm0 16.458V19H6v1.5C6 21.878 7.12 23 8.498 23h6.997a2.503 2.503 0 0 0 2.499-2.5Zm0-2.5V5.042H6V18h11.994ZM13.931 2.505a.5.5 0 0 1-.41.492l-.09.008h-2.998a.5.5 0 0 1-.09-.992l.09-.008h2.998a.5.5 0 0 1 .5.5Zm.904 9.348-3.998 3a.499.499 0 0 1-.854-.353v-6a.5.5 0 0 1 .854-.354l3.998 3a.5.5 0 0 1 0 .707Zm-1.06-.353-2.792-1.793v3.586l2.792-1.793ZM12.99 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.636-18.495a.5.5 0 0 1-1 0c0-.276.224-.505.5-.505.245 0 .45.173.492.405l.008.1Z",
    clipRule: "evenodd"
  })]
});